import React from "react";
import { Typography } from "@material-ui/core";
import styled from "styled-components";
import { Overlay } from "../../atoms";

const StyledContainer = styled.div`
  position: relative;
  margin-top: 92px;
`;

const StyledTitle = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const Banner = ({ title }: { title: string }) => {
  return (
    <StyledContainer>
      <Overlay
        image="/image/existing.jpg"
        height={250}
        positionImage="0% 64%"
        children={
          <StyledTitle>
            <Typography
              variant="h4"
              style={{ color: "white", fontWeight: 800 }}
            >
              {title}
            </Typography>
          </StyledTitle>
        }
      />
    </StyledContainer>
  );
};

export default Banner;
